module.exports = __webpack_public_path__ + "img/ico-bitman.f0517d9c.png";